import { Dispatch } from 'redux';

import { REDUX } from 'constants/index';
import actionCreator from '../lib/actionCreator';
import { getCurrentTreatiesData, getAllTreatiesData } from 'services/carrierTreatyYear';
import { getCurrentProgramYearsData, getAllProgramYearsData } from 'services/lumenProgramYear';

const currentTreatyAction = actionCreator(REDUX.BUSINESS_DATA_CURRENT_TREATIES);
const allTreatyAction = actionCreator(REDUX.BUSINESS_DATA_ALL_TREATIES);
const currentProgramYearAction = actionCreator(REDUX.BUSINESS_DATA_CURRENT_PROGRAM_YEARS);
const allProgramYearAction = actionCreator(REDUX.BUSINESS_DATA_ALL_PROGRAM_YEARS);

export function fetchCurrentTreaties() {
    return async (dispatch: Dispatch) => {
        dispatch(currentTreatyAction.loading());
        getCurrentTreatiesData()
            .then((treaties) => dispatch(currentTreatyAction.success(treaties)))
            .catch((reason) => dispatch(currentTreatyAction.error(reason || 'Treaty Error')));
    };
}

export function fetchAllTreaties() {
    return async (dispatch: Dispatch) => {
        dispatch(currentTreatyAction.loading());
        getAllTreatiesData()
            .then((treaties) => dispatch(allTreatyAction.success(treaties)))
            .catch((reason) => dispatch(allTreatyAction.error(reason || 'Treaty Error')));
    };
}

export function fetchCurrentProgramYears() {
    return async (dispatch: Dispatch) => {
        dispatch(currentProgramYearAction.loading());
        getCurrentProgramYearsData()
            .then((programYears) => dispatch(currentProgramYearAction.success(programYears)))
            .catch((reason) => dispatch(currentProgramYearAction.error(reason || 'Program Year Error')));
    };
}

export function fetchAllProgramYears() {
    return async (dispatch: Dispatch) => {
        dispatch(allProgramYearAction.loading());
        getAllProgramYearsData()
            .then((programYears) => dispatch(allProgramYearAction.success(programYears)))
            .catch((reason) => dispatch(allProgramYearAction.error(reason || 'Program Year Error')));
    };
}
